import React from "react";
import { styles } from "./styles";

const SnackbarCloseIcon = ({ src, ...props }) => {
  const classes = styles();
  return <img className={classes.closeIcon} alt="" src={src} {...props} />;
};

export default SnackbarCloseIcon;
